import { AdministrativeFeeCatalogDto } from './administrativefeecatalogdto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class AdministrativeFeeCatalogRequest {

    administrativeFeeCatalogDto: AdministrativeFeeCatalogDto = new AdministrativeFeeCatalogDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}